import { parseISO } from "date-fns";
import { fromZonedTime } from "date-fns-tz";
/**
 * Convert to UTC ISO string.
 * Supports:
 * - "YYYY-MM-DD"              → treated as 12:00 Europe/Oslo → UTC
 * - "YYYY-MM-DD HH:mm:ss"     → Europe/Oslo → UTC (space normalized to 'T')
 * - "YYYY-MM-DDTHH:mm[:ss]Z"  → already UTC
 * - "YYYY-MM-DDTHH:mm[:ss]"   → Europe/Oslo → UTC
 * - Date                      → toISOString()
 */
export const convertDateToRenewDateTime = (date) => {
    const normalizeSpaceDateTime = (v) => v.includes(" ") && !v.includes("T") ? v.replace(" ", "T") : v;
    if (typeof date === "string") {
        const trimmed = date.trim();
        if (trimmed.includes("T") || trimmed.includes(" ")) {
            const isoLike = normalizeSpaceDateTime(trimmed);
            if (isoLike.endsWith("Z")) {
                return parseISO(isoLike).toISOString();
            }
            const asUtc = fromZonedTime(isoLike, "Europe/Oslo");
            return asUtc.toISOString();
        }
        const localNoon = `${trimmed}T12:00:00`;
        const asUtc = fromZonedTime(localNoon, "Europe/Oslo");
        return asUtc.toISOString();
    }
    return date.toISOString();
};
